/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcOrdersV1OrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ORDERS_V1_ORDER_STATE_ENTITY_NAME = 'ixc.orders.v1.Order';
export const ixcOrdersV1OrderStateEntity = new schema.Entity<IxcOrdersV1OrderState>(IXC_ORDERS_V1_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'orderId' });

